export default __webpack_public_path__ + "static/media/spinner-plus.ed76de8b.svg";